var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9467 5.45337H7.79341H4.05341C3.41341 5.45337 3.09341 6.2267 3.54674 6.68004L7.00008 10.1334C7.55341 10.6867 8.45341 10.6867 9.00674 10.1334L10.3201 8.82004L12.4601 6.68004C12.9067 6.2267 12.5867 5.45337 11.9467 5.45337Z",
    fill: "#5A6F7E",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAccount);
export default __webpack_public_path__ + "static/media/arrow_account.33c5d6098f5dd58af017ad4aa5bd3c8f.svg";
export { ForwardRef as ReactComponent };